import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RegisterCompanyComponent } from 'src/views/register-company/register-company.component';
//import { CustomerPanelComponent } from 'src/views/customer-panel/customer-panel.component';
import { RegisterComponent } from 'src/views/register/register.component';
// import { PreLoginGuardGuard } from 'src/guards/pre-login-guard.guard';
// import { SiteComponent } from 'src/views/site/site.component';

const routes: Routes = [
  { path: '', redirectTo: 'customer', pathMatch: 'full'/*, canActivate: [ PreLoginGuardGuard ] */},
  // { path: '', redirectTo: 'site', pathMatch: 'full', canActivate: [ PreLoginGuardGuard ] },
  // { path: 'site', canActivate: [ PreLoginGuardGuard ], component: SiteComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'register/company', component: RegisterCompanyComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
